import React from "react";
import { Link } from "react-router-dom";
import { collections } from "../../../data/collections";
import { useSiteAssets, optimized } from "../../../siteAssets";
import styles from "./styles.module.css";

const CollectionsShowcase = () => {
  const assets = useSiteAssets();
  return (
    <section className={styles.wrap} id="collections">
      <div className={styles.head}>
        <div>
          <p className={styles.eyebrow}>Collections</p>
          <h2 className={styles.title}>Shop by Collection</h2>
        </div>
        <Link to="/collections" className={styles.viewAll}>
          View all collections →
        </Link>
      </div>

      <div className={styles.grid}>
        {collections.map((collection, i) => (
          <Link
            key={collection.id}
            to={`/shop?collection=${encodeURIComponent(collection.shopKey)}`}
            className={`${styles.card} ${i === 0 ? styles.cardFeatured : ""}`}
            style={{
              backgroundImage: `linear-gradient(to top, rgba(15,13,11,0.9) 0%, rgba(15,13,11,0.35) 55%, rgba(15,13,11,0.15) 100%), url(${
                assets[`collection-${collection.id}`]
                  ? optimized(assets[`collection-${collection.id}`])
                  : collection.heroImage
              })`,
            }}
          >
            <div className={styles.cardBody}>
              <span className={styles.season}>{collection.season}</span>
              <h3 className={styles.name}>{collection.name}</h3>
              <p className={styles.tagline}>{collection.tagline}</p>
              <p className={styles.story}>{collection.story}</p>
              <span className={styles.shop}>Shop the Collection →</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CollectionsShowcase;
